export default __webpack_public_path__ + "static/media/tour-e-agency-desktop-one.209bfdf3.png";